export default __webpack_public_path__ + "static/media/colour.eef6b82e.jpg";